import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { CurrencyPipe, DeviceService } from '@frontend/vanilla/core';

import { SessionPackageService } from '../../../services/session-package.service';
import { TeamModalPopupComponent } from '../../tickets/pre-buy-grid/team-modal-popup/team-modal-popup.component';

@Component({
    selector: 'bg-friends',
    templateUrl: 'friends.component.html',
    providers: [CurrencyPipe],
    imports: [CommonModule, TeamModalPopupComponent],
})
export class FriendsComponent implements OnInit {
    @Input() gameDetails: any;
    @Input() row_no: number;
    @Input() col_no: number;
    @Input() isPurchased: boolean;
    // @Input() isSessionBingo: boolean;
    // @Input() isPackageBingo: boolean;
    content: any = [];
    // @Output()('OnGamedetailsChange')
    // OnGamedetailsChange: EventEmitter<any> = new EventEmitter<any>();

    game: any;
    isMobile: boolean;
    currentGame: any;
    prebuynavlist: any;
    prebuynavcolitems: any;
    teamColors: any;
    assignIoClass: boolean;
    clientConfig: any;
    //     @Output('OnTeamModalOpen')
    //   OnTeamModalOpen: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        private deviceService: DeviceService,
        private sessionService: SessionPackageService,
        private dialog: MatDialog,
    ) {}
    ngOnInit() {
        //     this.game = this.gameDetails[0].game_Info[this.row_no];
        // } else {
        this.game = this.gameDetails[this.row_no].game_Info[this.col_no];
        // }
        if (localStorage.getItem('config')) {
            this.clientConfig = JSON.parse(localStorage.getItem('config')!);
        }
        this.content = this.clientConfig?.sessionGlobalMessages;

        this.isMobile = this.deviceService.isMobile;
        this.prebuynavlist = this.clientConfig?.bingoCategories;
        this.prebuynavlist?.forEach((val: any) => {
            if (val.categoryType == 'prebuytab') {
                this.prebuynavcolitems = val;
            }
        });
        if (this.prebuynavcolitems.columns.teamColors) this.teamColors = JSON.parse(this.prebuynavcolitems.columns.teamColors!);
        this.onRandomSelected();
    }

    selectTeam() {
        // let game = this.Games.filter(item => {
        //   return item.start_time == start_time;
        // });
        // if (this.isSessionBingo) {
        //     this.currentGame = this.gameDetails[0].game_Info[this.row_no];
        // } else {
        this.currentGame = this.gameDetails[this.row_no].game_Info[this.col_no];
        // }

        if (this.currentGame != undefined) {
            if (!this.isPurchased) {
                const requiredModalData = {
                    currentGame: this.currentGame,
                    teamColors: this.teamColors,
                };
                const dialogRef = this.dialog.open(TeamModalPopupComponent, {
                    data: requiredModalData,
                    panelClass: 'team-modal-popup',
                });
                dialogRef.componentInstance.onteamSelected.subscribe((response) => {
                    if (response) {
                        this.onTeamSelected(response.team);
                    }
                });
            }
            if (this.deviceService.isiOS && this.deviceService.isMobile) {
                this.sessionService.setClassStatusforIOS(true);
            }
            //this.OnTeamModalOpen.emit(true);
        }
    }

    onTeamSelected(team: any) {
        if (team != '') {
            this.currentGame.game_context.TeamBingo.current_team = team;
            // if (this.isSessionBingo) {
            // this.gameDetails[0].game_Info[this.row_no].game_context.TeamBingo.current_team = team;
            // } else {
            this.gameDetails[this.row_no].game_Info[this.col_no].game_context.TeamBingo.current_team = team;
            // }
            this.updateOnTicketsSelected();
        }
        this.sessionService.setClassStatusforIOS(false);
        //this.OnTeamModalOpen.emit(false);
    }
    onRandomSelected() {
        this.gameDetails.forEach((room: any) => {
            room.game_Info.forEach((element: any) => {
                if (element.game_context?.TeamBingo && element.game_context.TeamBingo.current_team == null) {
                    const RandomSelectIndex = Math.floor(Math.random() * element.game_context.TeamBingo.teams.length);
                    element.game_context.TeamBingo.current_team = element.game_context.TeamBingo.teams[RandomSelectIndex];
                }
            });
        });
        this.updateOnTicketsSelected();
        //this.OnTeamModalOpen.emit(false);
    }

    updateOnTicketsSelected() {
        this.sessionService.updateTicketsSelectedDetails({
            gameDetails: this.gameDetails,
        });
    }
}
